"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STEPPER_OUTLET_ID = void 0;
var STEPPER_OUTLET_ID = '#gifting-flow-stepper-container';
exports.STEPPER_OUTLET_ID = STEPPER_OUTLET_ID;